export default class FnEditorState {
    constructor(elements, selection) {
        this.elements = elements;
        this.selection = selection;
    }
}
